import React, { useEffect, useState } from 'react'
import { ReactComponent as IconTimes } from "assets/images/icons/project-icons/times.svg"
import useInlinePageRouter from 'components/__new/general/useInlinePageRouter';
import Maybe from 'components/__new/common/Maybe';
import WideViewModal from 'components/__new/common/WideViewModal';
import { useDispatch, useSelector } from 'react-redux';
import { clearPowerPreviewItems } from 'store/entities/billPayment/action';
import PowerPurchasePreview from './CablePurchasePreview';
import SingleCablePurchase from './SingleCablePurchase';
import MultipleCablePurchase from './MultipleCablePurchase';
import BulkCablePurchase from './BulkCablePurchase';
import CurrencyFormat from 'utils/currencyFormat';


const CablePurchaseType = ({
    isOpen,
    togglePurchaseModal,
    toggleBulkCableReview,
    setPreviewItems,
    tabItems,
    setPurchaseType,
    initiatePurchase,
    previewItems,
    defaultParams,
    generateClientReference,
    selectSingleBeneficiary,
    setSelectSingleBeneficiary
}) => {
    const dispatch = useDispatch();
    const { InlineRouterTab, activeTab } = useInlinePageRouter("single");
    const [isWideViewOpen, setIsWideViewOpen] = useState(false);
    const [totalFees, setTotalFees] = useState(0);
    const [subTotal, setSubTotal] = useState(0);
    const {powerPreviewItems} = useSelector((state) => state.entities.billPayment)
    
    const isMultipleTransfer = activeTab === "multiple";
    
    const closeModal = () => {
        setPreviewItems([]);
        dispatch(clearPowerPreviewItems());
        togglePurchaseModal();
    }
    
    const proceedToPurchase = () => {
        
        const params = {
                ...defaultParams,
                beneficiaries: previewItems.map((e) => {
                    return {
                        amount: parseInt(e.bouquet.amount) * 100,
                        account: e.account,
                        service: e.service,
                        decoderType: e.decoderType?.value === "startimes" ? "default" : e.decoderType?.value,
                        bouquetCode: e.bouquetCode,
                        type: e.type,
                        months: e.months,
                        addonCode: e.addonCode,
                        clientReference: generateClientReference(e.account),
                    }
                }),
            }
        togglePurchaseModal();
        initiatePurchase(params);
    }
    
    
    useEffect(() => {
        if(activeTab !== "multiple" && isWideViewOpen === true) {
            setIsWideViewOpen(false);
        }
        setPreviewItems([])
        // eslint-disable-next-line
    }, [activeTab])
    
    
    useEffect(() => {
        if(previewItems?.length > 0) {
            setTotalFees(previewItems?.reduce((acc, cur) => acc + cur.fee, 0))
            setSubTotal(previewItems?.reduce((acc, cur) => acc + cur.bouquet?.amount, 0))
        }
    }, [previewItems])
    
    
    useEffect(() => {
        if(isMultipleTransfer && powerPreviewItems?.length > 0 && isWideViewOpen === false) {
            setPreviewItems(powerPreviewItems);
            setIsWideViewOpen(true);
        }
        // eslint-disable-next-line
    }, [powerPreviewItems, isWideViewOpen])
    
    
    return (
        <WideViewModal wideViewControl={isWideViewOpen} size={"md"} wideViewClassName="w-[60%]" dialogPanelClassName="h-max-full" isOpen={isOpen} setIsOpen={() => {}}>
            <div className={`relative ${isWideViewOpen && "flex items-start justify-between"}`}>
                <div className={`${isWideViewOpen ? "w-2/5" : "w-full"}`}>
                    
                    <div className='pb-2 mb-4 border-b border-gray-200'>
                        <div className="flex items-center justify-between">
                            <div className="text-xl font-bold">
                                Purchase TV Subscription
                            </div>
                            
                            <Maybe condition={isWideViewOpen === false}>
                                <div onClick={closeModal} className='w-7 h-7 bg-[#f4f4f4] cursor-pointer rounded-md flex items-center justify-center'>
                                    <IconTimes width={30} />
                                </div>
                            </Maybe>
                        </div>
                        
                        <div className="pt-2 text-gray-600">
                            Pay for your Cable TV subscription
                        </div>
                    </div>
                    
                    <InlineRouterTab
                        tabMode
                        useFullWidth
                        items={tabItems}
                        onTabChange={(activeItem) => setPurchaseType(activeItem)}
                    />
                    
                    <div className="pt-4">
                        <Maybe condition={activeTab === "single"}>
                            <SingleCablePurchase 
                                initiatePurchase={initiatePurchase}
                                togglePurchaseModal={togglePurchaseModal}
                                defaultParams={defaultParams}
                                generateClientReference={generateClientReference}
                                selectSingleBeneficiary={selectSingleBeneficiary}
                                setSelectSingleBeneficiary={setSelectSingleBeneficiary}
                            />
                        </Maybe>
                        
                        <Maybe condition={activeTab === "multiple"}>
                            <MultipleCablePurchase 
                                previewItems={previewItems}
                                setPreviewItems={setPreviewItems}
                                togglePurchaseModal={togglePurchaseModal}
                                isWideViewOpen={isWideViewOpen}
                                setIsWideViewOpen={setIsWideViewOpen}
                            />
                        </Maybe>
                        
                        <Maybe condition={activeTab === "bulk"}>
                            <BulkCablePurchase 
                                togglePurchaseModal={togglePurchaseModal}
                                toggleBulkCableReview={toggleBulkCableReview}
                            />
                        </Maybe>
                    </div>
                </div>
                
                <Maybe condition={isWideViewOpen}>
                    <div style={{ height: "480px" }}  className='w-3/5 ml-5 flex flex-col justify-betweesn'>
                        <PowerPurchasePreview 
                            isOpen={isWideViewOpen}
                            previewItems={previewItems}
                            setPreviewItems={setPreviewItems}
                            setIsOpen={setIsWideViewOpen}
                        />
                        
                        <div className="rounded-xl py-1.5 px-3 w-full bg-ep-primary-light-100 mt-auto">
                            <div className="flex items-center justify-between w-full mb-2">
                                <p className="text-ep-gray-500 text-sm">Recipients</p>
                                <p className="text-ep-gray-600">{previewItems?.length}</p>
                            </div>
                            <div className="flex items-center justify-between w-full">
                                <p className="text-ep-gray-500 text-sm">Fees</p>
                                <p className="text-ep-gray-600">{totalFees}</p>
                            </div>
                            <div className="flex items-center justify-between w-full mt-1 border-t border-dashed pt-1">
                                <p className="text-ep-gray-600">Subtotal</p>
                                <p className="text-ep-gray-600">{CurrencyFormat(subTotal || 0)}</p>
                            </div>
                        </div>
                    </div>
                </Maybe>
            </div>
            
            <Maybe condition={isWideViewOpen === true}>
                <div className="w-full flex items-center justify-end border-t pt-5 mt-5">
                    <button type="button" onClick={closeModal} className="btn btn-transparent-primary mr-3">
                        Cancel
                    </button>
                    
                    <button onClick={proceedToPurchase} className="btn btn-ep-primary">
                        Continue
                    </button>
                </div>
            </Maybe>
        </WideViewModal>
    )
}

export default CablePurchaseType